import styled from 'styled-components';

export const FcRank = styled.span`
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 12px;
    line-height: 16px;
    color: #bababa;
`;

export const PlayerLastName = styled.span`
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 18px;
    font-weight: 700;
    margin-right: 3px;
    text-transform: uppercase;
    @media(max-width: 900px){
        font-size: 16px;
    }
`;

export const PlayerFirstName = styled(PlayerLastName)`
    font-size: 14px;
    font-weight: 400;
    @media(max-width: 900px){
        font-size: 12px;
    }
`;